import { render, staticRenderFns } from "./ButtonWidget.vue?vue&type=template&id=6b312c04&scoped=true"
import script from "./ButtonWidget.vue?vue&type=script&lang=js"
export * from "./ButtonWidget.vue?vue&type=script&lang=js"
import style0 from "./ButtonWidget.vue?vue&type=style&index=0&id=6b312c04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b312c04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b312c04')) {
      api.createRecord('6b312c04', component.options)
    } else {
      api.reload('6b312c04', component.options)
    }
    module.hot.accept("./ButtonWidget.vue?vue&type=template&id=6b312c04&scoped=true", function () {
      api.rerender('6b312c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/widgets/ButtonWidget.vue"
export default component.exports